module.exports = __webpack_public_path__ + "static/img/001.7641ac05.png";